import { Card, CardBody, Col, Row } from 'reactstrap'
import { StockMarkets } from '../../../../utils/Constant'
import ReactApexChart from 'react-apexcharts'
import { stockMarketChart } from '../../../../Data/Widgets/WidgetsChartData'
import Finance from './Finance'
import OrderStatusWidgets from './OrderStatusWidgets'
import MonthlySales from './MonthlySales'
import UsesWidgets from './UsesWidgets'
import CardHeaderCommon from '../../../../CommonElements/CommonCardHeader/CardHeaderCommon'

const StockMarket = () => {
  return (
    <Row>
      <Col sm="12" className="box-col-12">
        <div className="donut-chart-widget">
          <Card>
            <CardHeaderCommon title={StockMarkets} />
            <CardBody>
              <ReactApexChart options={stockMarketChart} series={stockMarketChart.series} type="line" height={450} />
            </CardBody>
          </Card>
        </div>
      </Col>
      <Finance />
      <OrderStatusWidgets />
      <MonthlySales />
      <UsesWidgets />
    </Row>
  )
}

export default StockMarket